export enum FilterOperator {
  LowerEqual = 'lte',
  GreaterEqual = 'gte',
}

export enum SortOrder {
  Desc = 'desc',
  Asc = 'asc',
}
